export const warnings = {
  'repeatable.render-number': 'Repeatable: expected number as index in render(). %type given.',
  'repeatable.new-index-number': 'The entry for the new index in a `Repeatable` should be a number, %type given',
  'repeatable.remove-index-number': 'The index for the item to be removed from `Repeatable` should be a number, %type given',
  'repeatable.id-and-subid': 'Item #%i is missing `id` or  `subId` property. The `createNewItems` method  has to return an array of items that have  both an `id` and a `subId` property.',
  'array.noArray': '`%s` has to be an array. %type given.',
  'object.noObject': '`%s` has to be an object. %type given.'
}
